export default __webpack_public_path__ + "static/media/Footwraps of the Darkwretch.7d92ecf2.jpg";